<template>
	<div  v-if='toolsDetail'>
		<div class="header">
			<div style="display: flex;align-items: center;">
				<img src="../../assets/images/indexIcon.png" alt="">
				<p><span>首页-解决方案池</span>-{{toolsDetail.title}}</p>
			</div>
			<div class="backof" @click="$router.go(-1)">返回</div>
		</div>
		<div class="body">
			<div class="body-left">
				<div class="left-head">
					发布人
				</div>
				<div class="left-body" v-if="toolsDetail.user_record == null">
					<div class="body-item">
						<div class="item-title">
							{{toolsDetail.user_info.nickname}}
						</div>
						<div class="item-content">
							
							联系方式:{{toolsDetail.user_info.mobile.slice(0, 3) + '****' + toolsDetail.user_info.mobile.slice(7)}}
						</div>
					</div>
					<!-- <div class="body-item">
						<div class="item-title">
							时间线
						</div>
						<div class="item-content">
							创建时间:2022-5-9
						</div>
						<div class="item-content">
							修改时间:2023-8-9
						</div>
					</div> -->
				
				
				</div>
				<div class="left-body" v-else>
					<div class="body-item">
						<div class="item-title">
							{{toolsDetail.user_record.name}}
						</div>
						<div class="item-content">
							联系方式:{{ toolsDetail.user_record.phone.slice(0, 3) + '****' + toolsDetail.user_record.phone.slice(7) || toolsDetail.user_record.email}}
						</div>
					</div>
					<div class="body-item">
						<div class="item-title">
							时间线
						</div>
						<div class="item-content">
							创建时间:{{timeConversion(toolsDetail.user_record.createtime)}}
						</div>
						<div class="item-content">
							修改时间:{{timeConversion(toolsDetail.user_record.updatetime)}}
						</div>
					</div>
					
				
				</div>
			</div>
			<div class="body-main">
				<div class="main-header">
					<div class="head-left">
						<img :src='getImgSrc(toolsDetail.image)' style="width: 238px;height: 238px;" alt="">
					</div>
					<div class="head-right">
						<div class="title">
							{{toolsDetail.title}}
						</div>
						<div class="content">
							<div class="content-l">
				
								<div class="content-item"><span
										class="biaoti">学科</span>：<span>{{toolsDetail.subjectcate_name}}</span></div>
								<div class="content-item"> <span
										class="biaoti">阶段</span>：<span>{{toolsDetail.stage_name}}</span></div>
								<div class="content-item"> <span class="biaoti">状态</span>：
									<span style="color: #0052D9;" v-if="toolsDetail.status == 2">应助中</span>
									<span style="color: #0052D9;" v-if="toolsDetail.status == 1">待审核</span>
									<span style="color: #0052D9;" v-if="toolsDetail.status == 3">已投条</span>
									<span style="color: #0052D9;" v-if="toolsDetail.status == 4">执行中</span>
									<span style="color: #0052D9;" v-if="toolsDetail.status == 5">已归档</span>
									<span style="color: #0052D9;" v-if="toolsDetail.status == 6">已存挡</span>
								</div>
				
								<!-- //状态:1=待审核,2=公布中,3=已投条,4=执行中,5=已归档,6=已存挡 -->
				
							</div>
							<div class="content-r">
								<div class="content-item"><span
										class="biaoti">行业</span>：<span>{{toolsDetail.industry_name}}</span></div>
								<div class="content-item"> <span class="biaoti">关 键
										词</span>：<span>{{toolsDetail.tags}}</span></div>
				
							</div>
						</div>
						<div class="bottom">
							<span style="color: #0052D9;"><i class="el-icon-view"
									style="font-size: 20px;"></i>{{toolsDetail.hits}}</span>
									
							<span style="margin-left:30px;cursor: pointer;" :style="toolsDetail.praise == 1?'color: #0052D9;':''"><i
									class="iconfont icon-zan"   v-throttle="[LikeHandler,2000,`click`]"
									style="font-size:20px;"></i>{{toolsDetail.praiset_num}}</span>
									
							<span style="margin-left: 30px;cursor: pointer;" :style="toolsDetail.tread==1?'color: #0052D9;':''"><i
									class="iconfont icon-lacai"   v-throttle="[ShitHandler,2000,`click`]"
									style="font-size: 18px;">{{toolsDetail.tread_num}}</i></span>
									
							<span style="margin-left: 30px;cursor: pointer;" :style="toolsDetail.collect == 1?'color: #0052D9;':''"><i 
									class="iconfont icon-xiai"  v-throttle="[collectasd,2000,`click`]"
									style="font-size: 18px;"></i>{{toolsDetail.collect_num}}</span>
									
							<div style="position: relative;" class="shareIconWrap">
								<span style="margin-left: 30px;cursor: pointer;" :style="toolsDetail.share == 1?'color: #0052D9;':''"><i
										class="iconfont icon-fenxiang" style="font-size: 20px;"></i>{{toolsDetail.share_num}}</span>
								<div class="shareIcon"
									style="position: absolute;background: #fff;width: 200px;display: flex;align-items: center;justify-content: center;left:0px;height: 50px;top:-50px">
									<goShare :zytitle="toolsDetail.title" @share='reoserceShare'></goShare>
								</div>
							</div>
				
						</div>
					</div>
				</div>
			<div class="main-body">
				<div class="title">
					<div :class="'active'">解决方案摘要</div>
			
				</div>
				<div class="showItem">
					<div>
						<p v-html="toolsDetail.summary_info"></p>
					</div>
			
				</div>
				
			</div>
			
			<div class="main-body">
				<div class="title">
					<div :class="'active'">购买完整版</div>
					
				</div>
				<div class="showItem">
						<div class="jieshao" style="color: black;">
							<div class="miaosu">
								告诉发布人我是谁：
							</div>
							<div class="content">
								<div class="wenJuan">
									<el-radio-group v-model="serveData.info_type" @input='clog' @change="jieshaoclear">
										<div style="margin: 25px 0;color: black;"><el-radio :label="1">使用系统中的个人信息</el-radio></div>
										<div style="margin: 25px 0;color: black;"><el-radio :label="2">使用学术/单位个人主页</el-radio><input
												:disabled='serveData.info_type !== 2' type="text" v-model="serveData.homepage"
												style="width: 300px;height: 30px;border: 1px solid #D2D2D2;"></div>
										<div style="margin: 25px 0;display: flex;align-items: center;"><el-radio
												:label="3">上传个人简历</el-radio><el-upload class="upload-demo"
												 :on-success='uploadSLT'  accept=".pdf,.doxc,.word,.txt" 
												:headers='{token:$store.state.userInfo.token}' :on-remove='removeFile'
												 :action="uploadPath+'common/upload'" multiple :limit="1"
												:disabled='serveData.info_type !== 3' :file-list="fileList">
												<el-button size="small" :style="serveData.info_type !== 3?'background-color: grey;border: none':''" type="primary">点击上传</el-button>
											</el-upload></div>
										<div style="margin: 25px 0;"><el-radio :label="4">直接介绍自己</el-radio> <input
												:disabled='serveData.info_type !== 4' type="text" v-model="serveData.content"
												style="width: 300px;height: 30px;border: 1px solid #D2D2D2;"></div>
									</el-radio-group>
								</div>
							</div>
						</div>
						<div class="jieshao" style="color: black;">
							<div class="miaosu">
								交易方式：
							</div>
							<div class="content">
								<div class="wenJuan">
									<el-radio-group v-model="serveData.pay_type" @input='clog' @change="clearInput">
										<div style="margin: 25px 0;color: black;" v-if='toolsDetail.price_type == 1'><el-radio  :label="1">对方报告免费，给他点个赞吧</el-radio></div>
										<div style="margin: 25px 0;color: black;" v-else><el-radio :label="2" style="width: 130px;">报价双方协商，预算：</el-radio><input
												:disabled='serveData.pay_type !== 2' type="number" placeholder="心里预算价位" v-model="serveData.price"
												style="width:100px;height: 30px;border: 1px solid #D2D2D2;padding-left: 10px;"></div>
									</el-radio-group>
								</div>
							</div>
						</div>
			
				</div>
				<div class="commit" @click="BuyHandler">提交</div>
			
			</div>


			</div>
	<div class="body-right">
				<div class="body-right">
					<div style="background: #0052D9;"  @click="$router.push('/solutionDetail/releaseSolution')">
						<img src='../../assets/images/zhifly.png' alt="" style="width: 20px;height: 18px;"><span
							style="width:80px">发布</span>
					</div>
					<div style="background: #3399FF;position: relative;" class="shareBox">
						<img src='../../assets/images/share.png' alt="" style="width: 19px;height: 19px;"><span
							style="width:80px">分享</span>
						<div class="share"
							style="position: absolute;left:0px;background: rgba(255, 255, 255, 0);width: 200px;display: flex;align-items: center;justify-content: center;left: 200px;height: 50px;">
							<goShare @share='reoserceShare' :zytitle="toolsDetail.title"></goShare>
						</div>
					</div>
					<div style="background: #FF8F00;">
						<img src='../../assets/images/whiteStar.png' alt="" style="width: 22px;height: 19px;"><span
							style="width:80px">关注</span>
					</div>
					<div style="background: #18BC9C;" @click="$router.push(`/solutionDetail/FAQ?type=${4}`)">
						<img src='../../assets/images/circlewen.png' alt="" style="width: 22px;height: 19px;"><span
							style="width:80px">常见问题</span>
					</div>
					<div style="background: #182349;"  @click="$router.push(`/userCenter/pthd/myMessage`)">
						<img src='../../assets/images/zixun.png' alt="" style="width: 20px;height: 19px;"><span
							style="width:80px">咨询作者</span>
					</div>
					<div style="background:#929292;" @click="$router.push(`/userCenter/pthd/myMessage?id=${0}`)">
						<img src='../../assets/images/error.png' alt="" style="width: 19px;height:18px;" ><span
							style="width:80px">纠错整改</span>
					</div>
				
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import goShare from '../../components/share.vue'
	export default {
		components: {
			goShare
		},
		data() {
			return {
				JSradio: '',
				fileList: [],
				title: '',
				whereForm: "",
				shoucang: false,
				noLike:false,
				heart:false,
				share:false,
				payRadio:'',
				toolsDetail: '',
				serveData:{
					scheme_id:'',
					info_type:1,//告诉发布人我是谁:1=系统信息,2=使用学术/单位个人主页,3=上传个人简历,4=直接介绍自己
					pay_type:1,//交易方式:1=免费,2=双方协商
					homepage:'',//
					file:'',
					price:'',
					content:''
				}
			}
		},
		created() {
			this.getToolDetail()
			
		},
		
		methods:{
			clearInput(){
				this.serveData.price = ''
			},
			jieshaoclear(){
				
			},
			async BuyHandler(){
				if(this.verifyBuy()){
					const buy =await this.$api.solutionBuyHandler({...this.serveData})
					if(buy.code == 1){
						this.$message({
							message:buy.msg,
							type:'success'
						})
					}else{
						this.$message({
							message:buy.msg,
							type:'warning'
						})
					}
				}
			},
			async getToolDetail() {
				const tool = await this.$api.getSolutionDetail({
					id: this.$route.query.id
				})
				this.serveData.scheme_id = tool.data.id
				console.log(tool.data);
				this.toolsDetail = tool.data
			},
			verifyBuy(){
				if(this.serveData.info_type == 2 & this.serveData.homepage == ''){
					this.$message({
						message:'请填写个人主页地址',
						type:'warning'
					})
					return false
				}
				if(this.serveData.info_type == 4 & this.serveData.content == ''){
					this.$message({
						message:'请填写个人介绍',
						type:'warning'
					})
					return false
				}
				if(this.serveData.info_type == 3 & this.serveData.file == ''){
					this.$message({
						message:'请填上传个人简历',
						type:'warning'
					})
					return false
				}
				return true
			},
			uploadSLT(e, a) {
				console.log(e.data.url);
				this.serveData.file = e.data.url
			},
			clog(e) {
				console.log(e);
			},
			removeFile(e,a){
				this.serveData.file =  ''
			},
			shareHandler(){
				this.share = !this.share
			},
			heartHandler(){
				this.heart = !this.heart
			},
			async reoserceShare(){
				// 1项目需求，2资源工具求助，3资源工具，4解决方案，5解决方案求助，6产品服务求助，7产品服务
				const share = await this.$api.shareHandler({correlation_id:this.toolsDetail.id,type:4})
				if (share.code == 1) {
					this.toolsDetail.share = 1
					this.toolsDetail.share_num += 1
				}
			},
			async collectasd() {
				let col
				if (this.toolsDetail.collect == 0) {
					 col = await this.$api.solutionCollectHandler({
						id: this.toolsDetail.id
					})
					if (col.code == 1) {
						this.toolsDetail.collect = 1
						this.toolsDetail.collect_num += 1
					}
				} else {
					 col = await this.$api.solutionCancelCollectHandler({
						id: this.toolsDetail.id
					})
					if (col.code == 1) {
						this.toolsDetail.collect = 0
						this.toolsDetail.collect_num -= 1
					}
				}
				this.$message({
					message: col.msg,
					type: 'success',
					center: true
				})
			},	
			async LikeHandler() {
				let like
				if (this.toolsDetail.praise == 0) {
					 like = await this.$api.solutionLikeHandler({
						id: this.toolsDetail.id
					})
					if (like.code == 1) {
						this.toolsDetail.praise = 1
						this.toolsDetail.praiset_num += 1
					}
				} else {
					 like = await this.$api.solutionCancelLikeHandler({
						id: this.toolsDetail.id
					})
					if (like.code == 1) {
						this.toolsDetail.praise = 0
						this.toolsDetail.praiset_num -= 1
					}
				}
				this.$message({
					message: like.msg,
					type: 'success',
					center: true
				})
			},
			// giveShitForTools
			// TakeBackShitFromTools
			async ShitHandler() {
				let shit
				if (this.toolsDetail.tread == 0) {
					 shit = await this.$api.giveShitHandler({
						correlation_id: this.toolsDetail.id,
						type:4
					})
					if (shit.code == 1) {
						this.toolsDetail.tread = 1
						this.toolsDetail.tread_num += 1
					}
				} else {
					 shit = await this.$api.cancelGiveShitHandler({
						correlation_id: this.toolsDetail.id,
						type:4
					})
					if (shit.code == 1) {
						this.toolsDetail.tread = 0
						this.toolsDetail.tread_num -= 1
					}
				}
				this.$message({
					message: shit.msg,
					type: 'success',
					center: true
				})
			},
			dianzan(type){
				if(type == 1){
					this.shoucang = !this.shoucang
					this.noLike = false
				}else{
					this.shoucang = false
					this.noLike = !this.noLike
				}
			},	
		}
	}
</script>
<style scoped>
	/* .el-radio__inner {
		border-radius: 0;
	} */
	.el-radio{
		color: black;
		width: 200px;
	}
	.el-radio-group{
		padding-left: 100px;
	}
/* 	.el-radio__inner::after {
		content: "";
		position: absolute;
		text-align: center;
		border-radius: 0;
		width: 14px;
		height: 14px;
		content: "✓";
		color: #fff;
		font-weight: bold;
		background-color: #0052D9;
	} */
</style>
<style lang="less" scoped>
	.shareIconWrap {
		.shareIcon {
			display: none !important;
		}
	
		&:hover {
			.shareIcon {
				display: block !important;
			}
		}
	}
	
	.shareBox {
		.share {
			display: none !important;
		}
	
		&:hover {
			.share {
				display: block !important;
			}
		}
	}
	.commit{
		width: 261px;
		height: 40px;
		background: #0052D9;
		color: white;
		line-height: 40px;
		text-align: center;
		margin: auto;
		cursor: pointer;
		font-size: 18px;
	}

	.body {
		display: flex;
		justify-content: space-between;
		.table{
			border: 1px solid #EEEEEE;
			text-align: center;
			.table-line{
				.jindu{
					width: 130px;
				}
				.line-status{
					width: 120px;
					border:  1px solid #EEEEEE;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
				}
				.starScore{
					font-size: 30px;
					width: 190px;
					border:  1px solid #EEEEEE;
					display: flex;
					height: 100%;
					align-items: center;
					justify-content: center;
				}
				.zhuanjia{
					display: flex;
					flex: 1;
					justify-content: flex-end;
					div{
						margin-right: 20px;
						width: 132px;
						color: #0052D9;
						height: 34px;
						border: 1px solid #0052D9;
						line-height: 34px;
						cursor: pointer;
					}
					&>div:last-child{
						background: #0052D9;
						color: white;
					}
				}
				.line-icon{
					width: 75px;
					display: flex;
					justify-content: center;
					border:  1px solid #EEEEEE;
					height: 100%;
					align-items: center;
					img{
						width: 23px;
						height: 23px;
					}
				}
				.line-id{
					font-size: 18px;
					width: 75px;
				}
				.fangan{
					width: 210px;
				}
				.nickName{
					width: 200px;
				}
				.company{
					width: 250px;
				}
				.deal{
					width: 180px;
				}
				.score{
					width: 120px;
				}
				.status{
					width: 170px;
				}
				align-items: center;
				display: flex;
				font-size: 16px;
				border-bottom: 1px solid #EEEEEE;
				height: 55px;
				.line-check{
					display: flex;
					align-items: center;
					justify-content: center;
					width: 50px;
					border:  1px solid #EEEEEE;
					height: 100%;
				}
			}
			.darkbg{
				background: #FAFAFA;
			}
		}
		.body-item-title {
			display: flex;
			justify-content: space-between;
			font-size: 18px;
			padding: 20px;
			align-items: center;
		
			&>div {
				cursor: pointer;
				line-height: 40px;
				text-align: center;
				padding: 0 10px;
				height: 40px;
				background: #F6F6F6;
				border: 1px solid #D2D2D2;
			}
		}
		.body-left {
			.left-body {
				.guanzhu {
					width: 230px;
					height: 46px;
					background: #0052D9;
					line-height: 46px;
					color: white;
					text-align: center;
					cursor: pointer;
				}

				.body-item {
					margin: 10px 0;
					margin-bottom: 30px;
				}

				.item-title {
					font-size: 18px;
					margin-bottom: 10px;
				}

				.item-content {
					margin: 5px 0;
					color: #888888;
				}

				padding: 10px 15px;
				box-sizing: border-box;
			}

			.left-head {
				font-size: 20px;
				line-height: 69px;
				padding-left: 15px;
				box-sizing: border-box;
				font-weight: bold;
				width: 260px;
				height: 69px;
				color: #0052D9;
				background: #E5EDFB;
			}

			width: 260px;
			height: 280px;
			background: #FFFFFF;
		}
		.body-mid-footer {
			display: flex;
			padding: 20px;
			box-sizing: border-box;
			height: 50px;
			background: #F6F6F6;
			justify-content: center;
			font-size: 18px;
			cursor: pointer;
			align-items: center;
			margin:10px auto;
			&>img {
				margin-left: 20px;
				width: 16px;
				height: 16px;
			}
		}
		.body-main {
			width: 900px;

			.main-body {
				.showItem {
					padding: 30px 25px;
					color: #888888;
					.bottom{
						height: 50px;
						background: #F6F6F6;
						border: 1px solid #EEEEEE;
						display: flex;
						line-height: 50px;
						padding-left: 30px;
						box-sizing: border-box;
						color: black;
					}
					.yingzu{
						display: flex;
						align-items: center;
						margin: 15px 0;
						img{
							width: 18px;
							height: 18px;
						}
						&>span{
							margin-left: 10px;
						}
						&>span:last-child{
							margin-left: 30px;
						}
					}
					p {
						overflow: hidden;
						text-overflow: ellipsis;
					}

					.wangpan {
						color: black;
						height: 200px;

						input {
							border: 1px solid #c6c6c6;
							height: 25px;
							padding-left: 5px;
							width: 200px;
						}
					}
				}

				.title {
					display: flex;
					height: 40px;
					background: #E5EDFB;

					&>div {
						height: 40px;
						line-height: 40px;
						cursor: pointer;
						font-size: 18px;
						text-align: center;
						color: #888888;
						padding: 0 20px;
					}

					.active {
						font-weight: bold;
						color: white;
						border-radius: 20px;
						height: 40px;
						background: #0052D9;
						border-radius: 0px 20px 20px 0px;
					}
				}

				margin-top: 20px;
				padding: 20px 0;
				box-sizing: border-box;
				background: white;
			}

			.main-header {
				display: flex;


				.content {
					margin-top: 10px;
					display: flex;

					.biaoti {
						width: 60px;
						display: inline-block;
						text-align: justify;
						text-align-last: justify;
						color: #888888;
					}

					.content-item {
						margin: 25px 5px;
						width: 280px;
					}

					.content-l {}
				}




				.head-right {
					flex: 1;
					padding: 8px 15px;
					box-sizing: border-box;
					.bottom{
						color: #888888;
						
						display: flex;
					}
					.title {
						font-size: 20px;
						font-weight: bold;
					}
				}

				display: flex;
				background: #FFFFFF;
				padding: 20px;
				box-sizing: border-box;
				background: white;
				height: 280px;
			}
		}

		.body-right {
			flex-wrap: wrap;
			display: flex;

			&>div {
				cursor: pointer;
				margin-bottom: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				color: white;
				line-height: 50px;
				width: 200px;
				height: 50px;
				background: #0052D9;

				&>img {
					margin-right: 15px;
				}
			}
		}
	}

	.header {
		.backof {
			text-align: center;
			line-height: 30px;
			cursor: pointer;
			width: 80px;
			height: 30px;
			background: #FFFFFF;
			border: 1px solid #D2D2D2;
		}

		display: flex;
		padding: 15px 0;
		align-items: center;
		justify-content: space-between;

		&>div {
			&>img {
				width: 16px;
				height: 16px;
			}

			&>p {
				font-size: 16px;
				margin-left: 10px;

				&>span {
					color: #888888;
				}
			}
		}
	}
</style>